// import {
// 	getFavoriteArticlesOptions,
// 	getFavoriteWorkshopsOptions,
// 	getProfileOptions,
// } from "@/api/queryOptions";
// import { queryClient } from "@/main";
import { MyAcademy } from "@/pages/MyAcademy/MyAcademy";
import { getAccessToken } from "@/utils/storage/authStorage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_app/my-academy")({
  component: MyAcademy,
  beforeLoad: async () => {
		const accessToken = await getAccessToken()
    if (accessToken === null || accessToken === undefined || accessToken === "") {
      redirect({
        to: '/login',
        throw: true,
        search: { returnTo: "/my-academy" },
      })
    }
	},
	// loader: async () => {
  //   return Promise.all([
  //       queryClient.ensureQueryData(getFavoriteArticlesOptions),
  //       queryClient.ensureQueryData(getFavoriteWorkshopsOptions),
  //       queryClient.ensureQueryData(getProfileOptions),
  //     ]);
	// }
});
